/**
 * Tenant-Settings Fixture — mirrors `/v1/admin/tenant-settings` Shape.
 * Schema-Quelle: migrations.md (tenants-Tabelle).
 */

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_TENANT_SETTINGS_DB__) {
    window.__ORBIT_TENANT_SETTINGS_DB__ = {
      email_from: 'noreply@valikey.app',
      logo_url: 'https://valikey.app/logo.svg',
      brand_color: '#3f6ad8',
      email_template: 'valikey',
      b2c_default_withdrawal_waived: false,
      application_fee_bps: 100,
    };
  }
  return window.__ORBIT_TENANT_SETTINGS_DB__;
}

export function tenantSettingsFixture() {
  return { settings: { ...(persist() ?? {}) } };
}

export function applyTenantSettingsPatch(patch) {
  const db = persist();
  if (!db) return;
  Object.entries(patch).forEach(([k, v]) => {
    db[k] = v;
  });
}
